import CheckboxInput from 'lib/components/Checkbox/CheckboxInput';
import { LoadingSpinner } from 'lib/components/LoadingSpinner';
import { LaunchDarklyFlags } from 'lib/types/launchDarklyFlags';
import { SearchableOrganizationRecord } from 'lib/types/searchable';
import { useBooleanFlag } from 'utils/flags';
import { PublisherFilters } from '../helpers/publisherSearch';
import { getLocationFilterCount } from './PublisherLocationFilter';
import { PublisherResultCard } from './PublisherResultCard';
import { formatOptions } from './SelectPublisherDropdown';
import PublisherNetworkTag from './PublisherNetworkTag';
import { SearchResultsSummaryDescription } from './SearchResultsSummaryDescription';

type PublisherSearchResultsListProps = {
  publisherOptions: SearchableOrganizationRecord[];
  loading: boolean;
  activeFilters: PublisherFilters;
  searchText: string;
  columnCertifiedFilter: boolean;
  setColumnCertifiedFilter: (value: boolean) => void;
  onPublisherOrganizationChange: (publisherOrganizationId: string) => void;
  setShowNetworkInfoModal: (value: boolean) => void;
};

export function PublisherSearchResultsList({
  publisherOptions,
  loading,
  activeFilters,
  searchText,
  columnCertifiedFilter,
  setColumnCertifiedFilter,
  onPublisherOrganizationChange,
  setShowNetworkInfoModal
}: PublisherSearchResultsListProps) {
  const showExternalPublisherFilter = useBooleanFlag(
    LaunchDarklyFlags.ENABLE_EXTERNAL_PUBLISHER_FILTER,
    false
  );
  const formattedPublisherOptions = publisherOptions.map(formatOptions);
  const activeFilterCount = getLocationFilterCount(activeFilters);
  const showResults =
    !loading && (searchText || activeFilterCount > 0 || columnCertifiedFilter);

  return (
    <>
      {showResults && (
        <div className="md:flex justify-between items-center my-4 space-y-2">
          <SearchResultsSummaryDescription
            searchText={searchText}
            publisherResults={publisherOptions}
            activeFilters={activeFilters}
          />
          {showExternalPublisherFilter && (
            <div className="self-end">
              <CheckboxInput
                inputPosition="left"
                id="column-certified-filter"
                checked={columnCertifiedFilter}
                onChange={setColumnCertifiedFilter}
                labelText="Show only Column partners"
              />
            </div>
          )}
        </div>
      )}
      {loading && (
        <div className="p-6">
          <LoadingSpinner />
        </div>
      )}
      <div className="space-y-3">
        {showResults &&
          formattedPublisherOptions.length > 0 &&
          formattedPublisherOptions.map(publisher => (
            <PublisherResultCard
              key={publisher.value}
              publisher={publisher}
              onSelect={onPublisherOrganizationChange}
              tags={
                showExternalPublisherFilter
                  ? [
                      <PublisherNetworkTag
                        key="network-tag"
                        isExtendedNetwork={publisher.isExternalPublisher}
                        onClick={() => setShowNetworkInfoModal(true)}
                      />
                    ]
                  : []
              }
            />
          ))}
      </div>
    </>
  );
}
